import { httpClient } from '@configs/httpclient.config';
import { AxiosResponse } from 'axios';
import { AccessRequestReq, AccessRequestResult, ResponseInfo } from '@libs/types';

export const SEND_ACCESS_REQUEST_URL = '/moex-datashop-reference-service/api/send_application/v1';

export const sendAccessRequest = async (
    body: AccessRequestReq,
): Promise<AxiosResponse<ResponseInfo<AccessRequestResult>>> => await httpClient.post(SEND_ACCESS_REQUEST_URL, body);
